import type { FC } from 'react';

export const ProductLogo: FC<{ className?: string }> = ({ className }) => {
    return (
        <div className={`flex justify-center ${className || ''}`}>
            <img 
                src="/assets/ai_korektury_logo.svg" 
                alt="AI Korektury" 
                className="h-12 w-auto"
            />
        </div>
    );
};